import { useQuery } from '@tanstack/react-query';
import { pb, TutorProfile } from '@/lib/pocketbase';

interface HeroTutorCard {
  id: string;
  tutorId: string;
  displayOrder: number;
  enabled: boolean;
  expand?: {
    tutorId?: TutorProfile;
  };
}

export const useHeroTutorCards = () => {
  const query = useQuery({
    queryKey: ['hero-tutor-cards-full'],
    queryFn: async () => {
      try {
        const records = await pb.collection('hero_tutor_cards').getFullList<HeroTutorCard>({
          filter: 'enabled = true',
          sort: 'displayOrder',
          expand: 'tutorId',
          requestKey: `hero-cards-${Date.now()}`,
        });
        
        // Return the full tutor profiles from the expanded relation
        const tutors = records
          .slice(0, 4)
          .map(card => card.expand?.tutorId)
          .filter(Boolean) as TutorProfile[];
        
        return tutors;
      } catch (error) {
        console.log('Hero tutor cards collection not found');
        return [];
      }
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  });

  return {
    heroTutors: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
